import Button from '@mui/material/Button';

export default function ButtonDemo() {
  return (
    // @focus-start @padding 2
    <Button href="/" variant="contained">
      Link
    </Button>
    // @focus-end
  );
}
